import { Danger, Error, Info, OkCircle } from '@atom-learning/icons'
import * as React from 'react'

import { InlineMessageTheme } from './InlineMessage.types'

export const INLINE_MESSAGE_ICONS: Record<
  InlineMessageTheme,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  success: OkCircle,
  warning: Danger,
  info: Info,
  neutral: Info,
  error: Error
}
